export { ThemeProvider } from './ThemeProvider'
export { molsonTheme } from './variants/MolsonTheme'

import { useTheme as muiUseTheme, type Theme } from '@mui/material/styles'
import { createStyled } from '@mui/system'

const molsonStyled = createStyled()
const molsonUseTheme = () => muiUseTheme<Theme>()

export { molsonStyled, molsonUseTheme }
